import type { LocalDate } from "@js-joda/core";
import { Api } from "services/api/api.service";
import type {
  StaffRegisterItem,
  StaffRegisterStatus,
} from "services/api/company/timeReports.service";
import { err, ok, type Result } from "utils/result";
import { formatLocalDateAsApiDate } from "web-apps/company/utils/timeAndDate";

interface LoadStaffStatusesParams {
  readonly companyId: number;
  readonly date: LocalDate;
}

const pageSize = 50;

const toStatusMap = (
  items: readonly StaffRegisterItem[],
): ReadonlyMap<number, StaffRegisterStatus> =>
  new Map(items.map(({ id, status }) => [id, status]));

export const loadScheduleDayStaffStatuses = async ({
  companyId,
  date,
}: LoadStaffStatusesParams): Promise<
  Result<ReadonlyMap<number, StaffRegisterStatus>, "request-failed">
> => {
  const dateKey = formatLocalDateAsApiDate(date);
  try {
    const firstPage = await Api().company.timeReports.getStaffRegister({
      companyId,
      fromDate: dateKey,
      page: 0,
      pageSize,
      toDate: dateKey,
    });
    const items = [...firstPage.data.items];
    const pageCount = Math.ceil(firstPage.data.total / pageSize);
    for (let page = 1; page < pageCount; page += 1) {
      const response = await Api().company.timeReports.getStaffRegister({
        companyId,
        fromDate: dateKey,
        page,
        pageSize,
        toDate: dateKey,
      });
      items.push(...response.data.items);
    }
    return ok(toStatusMap(items));
  } catch {
    return err("request-failed");
  }
};
